import React, { useState } from 'react';
import { Helmet } from 'react-helmet';  // Importera Helmet
import { Link } from 'react-router-dom'; // Glöm inte att importera Link
import StadContactForm from '../components/StadContactForm';

function Home() {
  return (
    <>
    <Helmet>
        <title>Provalt Service AB - Professionell Städ- & Trädgårdstjänster</title>
        <meta name="description" content="Provalt Service AB erbjuder professionell flyttstädning, hemstädning och trädgårdsarbete med garanti. Boka enkelt online och få snabb hjälp i hela Mälardalen." />
        <link rel="canonical" href="https://provalt.se/" />

      </Helmet>
      {/* Första sektionen med bakgrundsbild */}
      <section
        className="w-full h-[1000px] bg-cover bg-center px-4 sm:px-8 relative overflow-hidden"
        style={{ backgroundImage: `url('/images/startpage-bg.webp')` }}
      >
        <div className="absolute inset-0 bg-black bg-opacity-50 z-0"></div>
        <div className="flex items-center justify-center h-full relative z-10">
          <div className="text-center text-white max-w-4xl mx-auto">
            <h2 className="text-3xl sm:text-2xl font-bold mb-4">Professionella Städ- och Trädgårdstjänster <br/>under samma tak</h2>
            <p className="mb-4">Hållbar städning och trädgårdsvård, skräddarsydd för dig.</p>
            <a
              href="/contact"
              className="inline-block mt-4 px-4 py-2 bg-green-700 text-white rounded"
            >
              Kontakta Oss
            </a>
          </div>
        </div>
      </section>


      {/* Städsektion */}
      <section className="w-full py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">

          <p className="text-xl text-center text-gray-800 mb-2">
            <b>Provalt Service AB erbjuder professionella städ- och trädgårdstjänster för både privatpersoner och företag.</b><br/>
            Vi har många års erfarenhet och strävar alltid efter högsta kvalitet och hållbarhet i allt vi gör. 
            Oavsett om du behöver regelbunden kontorsstädning, storstädning av hemmet eller professionell trädgårdsskötsel, så ser vi till att leverera resultat som överträffar dina förväntningar.<br/><br/>
            Vi arbetar med miljövänliga produkter och moderna metoder för att säkerställa en hälsosam och trivsam miljö. 
            Våra pålitliga och certifierade medarbetare ser till att du får en trygg och effektiv service – helt anpassad efter dina behov.
          </p>
          <h4 className="text-2xl font-bold text-center text-gray-800 mb-8">Varför välja oss?</h4>
          <div className="flex flex-col md:flex-row justify-between mt-8 space-y-4 md:space-y-0 md:space-x-6">
            <div className="flex-1 p-6 text-center">
              <h3 className="text-lg font-semibold mb-2">Miljövänliga rengöringsmetoder</h3>
              <p>Vi använder skonsamma och hållbara produkter som är effektiva men samtidigt skonsamma mot både miljön och din hälsa. 
                Våra metoder minskar kemikalieanvändningen och bidrar till en renare och mer hållbar framtid.</p>
            </div>
            <div className="flex-1 p-6 text-center">
              <h3 className="text-lg font-semibold mb-2">Pålitliga & certifierade medarbetare</h3>
              <p>Vår erfarna personal är utbildad, certifierad och noggrant utvald för att säkerställa högsta kvalitet och service. 
                Vi ser till att varje uppdrag utförs med professionalism, punktlighet och omtanke.</p>
            </div>
            <div className="flex-1 p-6 text-center">
              <h3 className="text-lg font-semibold mb-2">Flexibla lösningar för hem & företag</h3>
              <p>Oavsett om du behöver en engångsstädning, regelbunden kontorsstädning eller trädgårdsskötsel anpassar vi våra tjänster efter dina specifika behov.</p>
            </div>
          </div>
          <div className="flex mt-6">
            <div className="flex-1 p-6 text-center">
              <h3 className="text-lg font-semibold mb-2">100% nöjd kund-garanti</h3>
              <p>Vi strävar alltid efter att överträffa dina förväntningar. Om du av någon anledning inte är helt nöjd med vårt arbete, åtgärdar vi det utan extra kostnad.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="w-full py-16 bg-gray-100">
        <div className="max-w-7xl mx-auto px-6">
          <h3 className="text-3xl font-bold text-center text-gray-800 mb-8">Våra Tjänster</h3>
          <h4 className="text-2xl font-bold text-center text-gray-800 mb-8">Städ</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Flyttstädning */}
            <Link to="/stad/flyttstadning" className="bg-white shadow-lg rounded-lg overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl">
              <img
                src="/images/provalt-flyttstädning.webp"
                alt="Flyttstädning"
                className="w-full max-w-[380px] h-48 object-cover mx-auto"
              />
              <div className="p-6 text-center">
                <h4 className="text-xl font-semibold text-gray-800 mb-2">Provalt Flyttstädning</h4>
                <p className="text-gray-600">Vi erbjuder noggrann och effektiv flyttstädning, där vi ser till att ditt gamla hem eller kontor är i toppskick inför nästa hyresgäst eller köpare.</p>
              </div>
            </Link>
            {/* Fönsterputs */}
            <Link to="/stad/fonsterputs" className="bg-white shadow-lg rounded-lg overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl">
              <img
                src="/images/provalt-fönsterputs.webp"
                alt="Fönsterputs"
                className="w-full max-w-[380px] h-48 object-cover mx-auto"
              />
              <div className="p-6 text-center">
                <h4 className="text-xl font-semibold text-gray-800 mb-2">Provalt Fönsterputs</h4>
                <p className="text-gray-600">Vi utför professionell fönsterputsning både in- och utvändigt, så att dina fönster alltid är kristallklara och fria från smuts och fläckar.</p>
              </div>
            </Link>
            {/* Trappstädning */}
            <Link to="/stad/trappstadning" className="bg-white shadow-lg rounded-lg overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl">
              <img
                src="/images/provalt-flyttstädning.webp"
                alt="Trappstädning"
                className="w-full max-w-[380px] h-48 object-cover mx-auto"
              />
              <div className="p-6 text-center">
                <h4 className="text-xl font-semibold text-gray-800 mb-2">Provalt Trappstädning</h4>
                <p className="text-gray-600">Vi tar hand om trapphus och gemensamma ytor med regelbundna städningar som håller dina utrymmen rena och fräscha.</p>
              </div>
            </Link>
            {/* Kontorsstädning */}
            <Link to="/stad/kontorsstadning" className="bg-white shadow-lg rounded-lg overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl">
              <img
                src="/images/provalt-kontorsstädning.webp"
                alt="Kontorsstädning"
                className="w-full max-w-[380px] h-48 object-cover mx-auto"
              />
              <div className="p-6 text-center">
                <h4 className="text-xl font-semibold text-gray-800 mb-2">Provalt Kontorsstädning</h4>
                <p className="text-gray-600">Vi erbjuder skräddarsydd kontorsstädning för att skapa en trivsam arbetsmiljö, med allt från daglig städning till djuprengöring av specifika ytor.</p>
              </div>
            </Link>
            {/* Byggstädning */}
            <Link to="/stad/byggstadning" className="bg-white shadow-lg rounded-lg overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl">
              <img
                src="/images/provalt-byggstädning.webp"
                alt="Byggstädning"
                className="w-full max-w-[380px] h-48 object-cover mx-auto"
              />
              <div className="p-6 text-center">
                <h4 className="text-xl font-semibold text-gray-800 mb-2">Provalt Byggstädning</h4>
                <p className="text-gray-600">Efter byggprojekt eller renoveringar tar vi hand om byggdamm och skräp, så att du får en ren och säker miljö att arbeta eller bo i.</p>
              </div>
            </Link>
            {/* Lokalvård */}
            <Link to="/stad/lokalvard" className="bg-white shadow-lg rounded-lg overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl">
              <img
                src="/images/cleaning/provalt-lokalvård-2.webp"
                alt="Lokalvård"
                className="w-full max-w-[380px] h-48 object-cover mx-auto"
              />
              <div className="p-6 text-center">
                <h4 className="text-xl font-semibold text-gray-800 mb-2">Provalt Lokalvård</h4>
                <p className="text-gray-600">Vi ser till att dina lokaler är rena, fräscha och välkomnande, oavsett om det gäller kontor, butiker eller bostäder.</p>
              </div>
            </Link>
          </div>
        </div>
      </section>
      {/* Trädgårdssektion */}
      <section className="w-full py-16 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h4 className="text-2xl font-bold text-center text-gray-800 mb-8">Trädgård</h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Trädgårdsskötsel */}
            <Link to="/tradgard/tradgardsskotsel" className="bg-white shadow-lg rounded-lg overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl">
              <img
                src="/images/provalt-trädgårdsskötsel.webp"
                alt="Trädgårdsskötsel"
                className="w-full max-w-[380px] h-48 object-cover mx-auto"
              />
              <div className="p-6 text-center">
                <h4 className="text-xl font-semibold text-gray-800 mb-2">Trädgårdsskötsel</h4>
                <p className="text-gray-600">Håll din trädgård välvårdad året runt med våra professionella tjänster för ogräsrensning, gräsklippning och allmän skötsel.</p>
              </div>
            </Link>
            
            {/* Plantering */}
            <Link to="/tradgard/plantering" className="bg-white shadow-lg rounded-lg overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl">
              <img
                src="/images/provalt-plantering.webp"
                alt="Plantering"
                className="w-full max-w-[380px] h-48 object-cover mx-auto"
              />
              <div className="p-6 text-center">
                <h4 className="text-xl font-semibold text-gray-800 mb-2">Plantering</h4>
                <p className="text-gray-600">Få professionell hjälp med att plantera blommor, buskar och träd för att ge din trädgård nytt liv och färg.</p>
              </div>
            </Link>
            
            {/* Lövblåsning */}
            <Link to="/tradgard/lovblasning" className="bg-white shadow-lg rounded-lg overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl">
              <img
                src="/images/provalt-lövblåsning.webp"
                alt="Lövblåsning"
                className="w-full max-w-[380px] h-48 object-cover mx-auto"
              />
              <div className="p-6 text-center">
                <h4 className="text-xl font-semibold text-gray-800 mb-2">Lövblåsning</h4>
                <p className="text-gray-600">Vi ser till att din trädgård är fri från löv och kvistar, så att du får en städad och snygg trädgård under hösten.</p>
              </div>
            </Link>
          </div>
          <div className="flex justify-center mt-8">
            <Link
              to="/tradgard/snoskottning"
              className="bg-white shadow-lg rounded-lg overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl w-full max-w-[380px]"
            >
              <img
                src="/images/provalt-snöplog.webp"
                alt="Snöskottning"
                className="w-full h-48 object-cover"
              />
              <div className="p-6 text-center">
                <h4 className="text-xl font-semibold text-gray-800 mb-2">Vinterunderhåll</h4>
                <p className="text-gray-600">Vi erbjuder vinterunderhåll för både privata och kommersiella fastigheter, så att du slipper oroa dig för vintervädret.</p>
              </div>
            </Link>
          </div>
        </div>
      </section>


      <section className="w-full py-16 bg-gray-100">
        <h4 className="text-2xl font-bold text-center text-gray-800 mb-8 py-6">Kontakta oss!</h4>

        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div>
            <h2 className="text-2xl font-bold mb-4 text-gray-800">Våra Tjänster</h2>
            <p className="text-gray-700 mb-4">
              Vi erbjuder heltäckande lösningar för både hem och företag – från städning till trädgårdsskötsel. 
              Behöver du regelbunden kontorsstädning, en grundlig storstädning, fönsterputs eller hjälp med gräsklippning, häcktrimning eller plantering? Vi finns här för att hjälpa till.      
            </p>
            <p className="text-gray-700 mb-4">
              För företag skapar vi en ren och professionell miljö som bidrar till trivsel och effektivitet. 
              För privatpersoner ser vi till att hemmet blir skinande rent och trädgården en plats att trivas i. 
              Vi har lång erfarenhet och tar även hand om mer specifika uppdrag som flyttstädning eller avancerad trädgårdsskötsel.
            </p>
            <p className="text-gray-700">
              Våra tjänster är flexibla och anpassas efter dina behov – oavsett om du är privatperson eller företagskund.<br/><br/>
            </p>
            <p className="text-gray-700 font-bold">
              Kontakta oss för en kostnadsfri offert – vi gör din vardag enklare och dina miljöer trivsamma, både inne och ute.
            </p>
          </div>

          <div className="bg-gray-200 p-8 rounded-lg shadow">
            <h3 className="text-xl font-semibold mb-6 text-gray-800">Kontaktformulär</h3>
            <StadContactForm />

          </div>
        </div>
      </section>


    </>
  );
}

export default Home;
